import styled, { createGlobalStyle } from 'styled-components';
import { pickThemeFontStyles } from '@/theme';

export const StyledBulkActionsBar = styled.div`
  display: flex;
  gap: 2rem;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 1rem;

  p {
    margin: 0;
    ${pickThemeFontStyles('16', '20')}
  }
`;

export const PopoverOverlayGlobalStyles = createGlobalStyle`
.bulk-delete-popover {
  .ant-popover-content {
    .ant-popover-inner {
      padding: 0.5rem 1rem;
      border-radius: 0.325rem;

      .ant-popover-title {
        text-align:center;
        margin: 0;
      }
    }
  }
}
`;
